var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VueSlider',_vm._b({attrs:{"value":_vm.progress,"min":0,"max":1,"interval":0.00001,"lazy":true,"contained":true,"dot-options":{tooltip: 'always'},"tooltip-formatter":_vm.formatter},on:{"change":_vm.seek}},'VueSlider',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }